import {useState} from "react";
import {useUser} from "../../lib/hooks";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {
    Avatar,
    Box,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    styled,
    Tooltip,
    Typography
} from "@mui/material";
import {DarkModeRounded, LightModeRounded, LogoutRounded, SupervisedUserCircleRounded} from "@mui/icons-material";
import useThemeStore from "../../store/theme";
import SwitchButton from "./switchButton";
import {PropTypes} from "prop-types";

const Navigation = ({navItemProps, onLoginBtnClick, onLogoutBtnClick, ...props}) => {

    const navItems = [
        {
          title: "اشتراک گذاری فوری",
          href: "/#quick-access",
        },
        {
          title: "درخواست ارسال",
          href: "/request-share",
        },
        {
          title: "ساخت ایمیل",
          href: "https://mailfa.com/email/create",
        },
        {
          title: "تعرفه ها",
          href: "/plans",
        },
        {
          title: "درایو",
          href: "/drive",
        },
        {
          title: "دانلود",
          href: "/download",
        },
        {
          title: "درباره ما",
          href: "/about-us",
        },
        {
          title: "تماس با ما",
          // href: "/contact-us",
          href: "https://mailfa.com/support",
        }
    ]
    const user = useUser();
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const {mode, setMode} = useThemeStore();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <List {...props}>
            {navItems.map((i, ind) => (
                <NavItem key={ind} href={i.href} title={i.title} {...navItemProps}/>
            ))}
            <StyledListItem onClick={() => setMode(mode === 'light' ? 'dark' : 'light')}>
                <Tooltip title={mode === 'light' ? 'تغییر تم به تاریک' : 'تغییر تم به روشن'}>
                    <SwitchButton>
                        {
                            mode === 'light'
                                ?
                                <>
                                    <LightModeRounded/>
                                    <Typography ml={.5} fontSize=".85rem" sx={{ display: {lg: "none"} }}>تم روشن</Typography>
                                </>
                                :
                                <>
                                    <DarkModeRounded/>
                                    <Typography ml={.5} fontSize=".85rem" sx={{ display: {lg: "none"} }}>تم تاریک</Typography>
                                </>
                        }
                    </SwitchButton>
                </Tooltip>
            </StyledListItem>
            <StyledListItem disablePadding {...navItemProps}>
                {user
                    ?
                    <Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            flexDirection={{xs: "column",lg: "row"}}
                            sx={{ cursor: "pointer", userSelect: "none" }}
                            id="profile-menu-button"
                            aria-controls={open ? 'profile-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                        >
                            {user.Avtar
                                ?
                                <Avatar src={user.avatar}/>
                                :
                                <Avatar>{user.firstName ? user.firstName[0] : "A"}</Avatar>
                            }
                            <Typography mt={{ xs: 1, lg: 0 }} ml={{lg: 1}} fontSize={{xs: "1rem", lg: ".9rem"}} fontWeight={500}>{user.firstName + " " + user.lastName} عزیز، خوش آمدید</Typography>
                            <Box component={Link} to="/drive" sx={{ display: {lg: "none"}, mt: .25 }}>
                                <Button>مشاهده پنل کاربری</Button>
                            </Box>
                        </Box>
                        <Menu
                            id="profile-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            PaperProps={{ sx: { display: {xs: "none", lg: "block"}, borderRadius: 2 }, elevation: 25 }}>
                            <Link to="/drive">
                                <MenuItem onClick={handleClose}>
                                    <ListItemIcon>
                                        <SupervisedUserCircleRounded color="primary" fontSize="small"/>
                                    </ListItemIcon>
                                    <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>پنل کاربری</ListItemText>
                                </MenuItem>
                            </Link>
                            <MenuItem onClick={() => {handleClose(); onLogoutBtnClick();}}>
                                    <ListItemIcon>
                                        <LogoutRounded color="error" fontSize="small"/>
                                    </ListItemIcon>
                                    <ListItemText disableTypography sx={{ fontSize: ".875rem" }}>خروج از حساب</ListItemText>
                                </MenuItem>
                        </Menu>
                    </Box>
                    :
                    <Button onClick={onLoginBtnClick} variant="contained" sx={{ width: {xs: "100%", lg: "auto"}, px: 4, py: 1.25 }} disableElevation>ورود / ثبت نام</Button>
                }
            </StyledListItem>
        </List>
    )
}
export default Navigation;

const NavItem = (props) => {

    const {title, href, ...restProps} = props
    const {pathname} = useLocation();

    return (
        <StyledListItem className={ pathname === href ? "Mui-active" : '' } {...restProps}>
            <Link to={href}>{title}</Link>
        </StyledListItem>
    )
};
NavItem.propTypes = {
    title: PropTypes.string,
    href: PropTypes.string,
}
const StyledListItem = styled(ListItem)(({theme}) => ({
    fontSize: ".985rem",
    fontWeight: 500,
    whiteSpace: "nowrap",
    transition: "color .2s ease-in-out",
    "&:hover, &.Mui-active": {color: theme.palette.primary.main},
}));
